@if (
  engineProposal()?.canAccept === false || engineProposal()?.canReject === false
) {
  <div class="container">
    <onyx-message intent="information">
      <onyx-icon name="tooltip-filled" [size]="20"></onyx-icon>

      {{ `${I18N}.optimizedAssignments` | translate }}
    </onyx-message>

    <onyx-button class="accept" (click)="showOnMap()">
      {{ 'labels.showOnMap' | translate }}
    </onyx-button>
  </div>
} @else {
  <div class="grid">
    <onyx-button
      variant="outlined"
      color="red"
      [onyxDropdownOptions]="rejectOptions$ | async"
      [onyxDropdownWidth]="360"
      (onyxDropdownSelectedValueChange)="$event.value?.()"
    >
      {{ 'labels.reject' | translate }}
    </onyx-button>

    <onyx-button
      variant="outlined"
      [onyxDropdownOptions]="changeOptions$ | async"
      [onyxDropdownWidth]="360"
      (onyxDropdownSelectedValueChange)="$event.value?.()"
    >
      {{ 'labels.change' | translate }}
    </onyx-button>

    <onyx-button class="accept" (click)="accept()">
      {{ 'labels.accept' | translate }}
    </onyx-button>
  </div>
}
